import httpClient from '../httpClient';
import {
  inProgressStatuses,
  upcomingStatuses
} from './../../utils/rentalStatuses';

export default {
  searchCarpoolings({
    start_station_id,
    end_station_id,
    rental_label_id,
    start_time,
    end_time,
    categories,
    page,
    limit
  }) {
    return httpClient('v0.4').post('/carpooling_rentals/search', {
      search: {
        start_station_id,
        end_station_id,
        rental_label_id,
        start_time,
        end_time,
        categories,
        page,
        limit
      },
      page: 1,
      limit: 30
    });
  },
  getPassengers(rentalId) {
    return httpClient('v0.4').get(`/rentals/${rentalId}/passengers`);
  },
  createNewPassenger(rentalId, email) {
    return httpClient('v0.4').post(`/rentals/${rentalId}/passengers`, {
      passenger: {
        email: email
      }
    });
  },
  getAllCarpoolings(params) {
    return httpClient('v0.4').get('/user/carpooling_rentals', {
      params: params
    });
  },
  getAll(params) {
    // return httpClient('v0.4').get('/rentals', { params });
    return httpClient('v0.4').get('/user/rentals', { params });
  },
  getOne(id) {
    return httpClient('v0.4').get(`/user/rentals/${id}`);
  },
  createRental({
    vehicleId,
    driverId,
    startStationId,
    endStationId,
    destinationId,
    startTime,
    endTime,
    estimatedDistance,
    rentalLabelId,
    discountCodes,
    geotracking,
    carpooling,
    carpoolingDestination
  }) {
    return httpClient('v0.4').post('/user/rentals', {
      vehicle_id: vehicleId,
      driver_id: driverId,
      start_station_id: startStationId,
      end_station_id: endStationId,
      destination_id: destinationId,
      reservation_start_time: startTime,
      reservation_end_time: endTime,
      estimated_distance: estimatedDistance,
      rental_label_id: rentalLabelId,
      discount_codes: discountCodes,
      geotracking: geotracking,
      carpooling: carpooling,
      carpooling_destination: carpoolingDestination
    });
  },
  createPassenger(rentalId) {
    return httpClient('v0.4').post(`/user/rentals/${rentalId}/passengers`);
  },
  deletePassenger(rentalId, passengerId) {
    return httpClient('v0.4').delete(
      `/rentals/${rentalId}/passengers/${passengerId}`
    );
  },
  cancelRental(id) {
    return httpClient('v0.4').delete(`/user/rentals/${id}`);
  },
  updateRental({ id, startTime, endTime }) {
    return httpClient('v0.4').put(`/user/rentals/${id}`, {
      reservation_start_time: startTime,
      reservation_end_time: endTime
    });
  },
  updatePrivacyUsage({ id, geotracking }) {
    return httpClient('v0.4').put(`/user/rentals/${id}`, {
      rental: {
        geotracking: geotracking
      }
    });
  }
};
